import React, { useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Hunt from './pages/Hunt'
import Puzzle from './pages/Puzzle'
import Admin from './pages/Admin'
import { getDeviceSensorsManager } from './utils/device-sensors'

function App() {
  useEffect(() => {
    // Initialize device sensors on app mount
    const sensorsManager = getDeviceSensorsManager()
    sensorsManager.init().then(hasCompass => {
      console.log('✓ Device compass initialized:', hasCompass)
    }).catch(err => {
      console.error('Failed to initialize device sensors:', err)
    })
  }, [])

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Hunt />} />
        <Route path="/puzzle" element={<Puzzle />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
    </Router>
  )
}

export default App
